import { useTheme } from "../../context/ThemeContext";
import { cn } from "../../lib/utils";

export default function KPICard({ 
  title, 
  value, 
  subtitle, 
  icon: Icon, 
  trend, 
  trendValue,
  className,
  variant = "default" 
}) {
  const { theme } = useTheme();

  const variants = {
    default: theme === 'dark' 
      ? "border-white/5 hover:border-white/10" 
      : "border-slate-200 hover:border-slate-300",
    blue: theme === 'dark'
      ? "border-blue-500/20 hover:border-blue-500/40 bg-gradient-to-br from-blue-500/10 to-transparent"
      : "border-blue-200 hover:border-blue-300 bg-gradient-to-br from-blue-50 to-transparent",
    green: theme === 'dark'
      ? "border-emerald-500/20 hover:border-emerald-500/40 bg-gradient-to-br from-emerald-500/10 to-transparent"
      : "border-emerald-200 hover:border-emerald-300 bg-gradient-to-br from-emerald-50 to-transparent",
    purple: theme === 'dark'
      ? "border-purple-500/20 hover:border-purple-500/40 bg-gradient-to-br from-purple-500/10 to-transparent"
      : "border-purple-200 hover:border-purple-300 bg-gradient-to-br from-purple-50 to-transparent",
    amber: theme === 'dark'
      ? "border-amber-500/20 hover:border-amber-500/40 bg-gradient-to-br from-amber-500/10 to-transparent"
      : "border-amber-200 hover:border-amber-300 bg-gradient-to-br from-amber-50 to-transparent",
  };

  const iconColors = {
    default: theme === 'dark' ? "text-slate-400" : "text-slate-500",
    blue: "text-blue-500",
    green: "text-emerald-500",
    purple: "text-purple-500",
    amber: "text-amber-500",
  };

  return (
    <div
      className={cn(
        "border rounded-xl p-6 transition-all duration-300",
        theme === 'dark' ? 'bg-[#012169]' : 'bg-white shadow-sm hover:shadow-md',
        variants[variant],
        className
      )}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className={cn(
            "text-sm font-medium",
            theme === 'dark' ? 'text-slate-400' : 'text-slate-500'
          )}>
            {title}
          </p>
          <p className={cn(
            "mt-2 text-3xl font-bold",
            theme === 'dark' ? 'text-white' : 'text-[#011a3a]'
          )}>
            {value}
          </p>
          {subtitle && (
            <p className={cn(
              "mt-1 text-sm",
              theme === 'dark' ? 'text-slate-500' : 'text-slate-400'
            )}>
              {subtitle}
            </p>
          )}
          {trend && (
            <div className="mt-2 flex items-center gap-1">
              <span
                className={cn(
                  "text-sm font-medium",
                  trend === "up" ? "text-emerald-500" : "text-red-500"
                )}
              >
                {trend === "up" ? "↑" : "↓"} {trendValue}
              </span>
              <span className={cn(
                "text-xs",
                theme === 'dark' ? 'text-slate-500' : 'text-slate-400'
              )}>
                vs last period
              </span>
            </div>
          )}
        </div>
        {Icon && (
          <div className={cn(
            "p-3 rounded-lg",
            theme === 'dark' ? 'bg-white/5' : 'bg-slate-100',
            iconColors[variant]
          )}>
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>
    </div>
  );
}
